export default __webpack_public_path__ + "static/media/tete15.7ab8d709.png";